import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Profile from "./Profile";
import Deposit from "./Deposit";
import Withdraw from "./Withdraw";
import BettingRecords from "./BettingRecords";
import AccountRecord from "./AccountRecord";
import ProfitLoss from "./ProfitLoss";
import RewardCenter from "./RewardCenter";
import Invite from "./Invite";
import Internal from "./Internal";
import OutsideClickHandler from "react-outside-click-handler";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import Vip from "./Vip";
import ReferenceAccountFeatures from "./ReferenceAccountFeatures";
import ManualRebate from "./ManualRebate";
import { FaUserCircle, FaClipboardList, FaHistory, FaChartLine, FaGift, FaUserFriends, FaTasks, FaEnvelope, FaCoins, FaWallet, FaMoneyBillWave } from "react-icons/fa";

const RAIL_ICONS = {
  account: FaUserCircle, betting: FaClipboardList, accountRecord: FaHistory,
  profitLoss: FaChartLine, rewardCenter: FaGift, invite: FaUserFriends,
  mission: FaTasks, internal: FaEnvelope, rebate: FaCoins,
  deposit: FaWallet, withdraw: FaMoneyBillWave,
};

const NAV_ITEMS = [
  ["account", "My Account", "icon_securityCenter", "securityCenter"],
  ["betting", "Betting Record", "icon_personalHistoryCopy", "personalHistoryCopy"],
  ["accountRecord", "Account Record", "icon_transactionHistory", "transactionHistory"],
  ["profitLoss", "Profit And Loss", "icon_personalProfit", "personalProfit"],
  ["rewardCenter", "Reward Center", "icon_rewardCenter", "rewardCenter"],
  ["invite", "Invite Friends", "icon_referral", "referral"],
  ["mission", "Mission", "icon_task", "mission", 3],
  ["internal", "Internal Message", "icon_messageV2", "internal"],
  ["rebate", "Manual rebate", "icon_rebate", "rebate"],
];

const Index = ({ embedded = false }) => {
  const [params, setParams] = useSearchParams();
  const initialTab = params.get("tab") || "account";
  const [tab, setTab] = useState(initialTab);
  const accountRail = useRef(null);
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const setAccountModal = useContextSelector(AuthContext, (ctx) => ctx.setAccountModal);
  const accountModal = useContextSelector(AuthContext, (ctx) => ctx.accountModal);

  const selectTab = (next) => {
    setTab(next);
    setAccountModal({ type: next, status: true });
    if (embedded) {
      setParams(next === "account" ? {} : { tab: next }, { replace: true });
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  };

  const screens = {
    account: <Profile setTab={selectTab} embedded={embedded} />,
    deposit: <Deposit setTab={selectTab} embedded={embedded} />,
    withdraw: <Withdraw setTab={selectTab} />,
    betting: <BettingRecords setTab={selectTab} />,
    accountRecord: <AccountRecord setTab={selectTab} />,
    profitLoss: <ProfitLoss setTab={selectTab} embedded={embedded} />,
    rewardCenter: <RewardCenter setTab={selectTab} />,
    invite: <Invite setTab={selectTab} />,
    internal: <Internal setTab={selectTab} />,
    mission: <ReferenceAccountFeatures type="mission" />,
    rebate: <ManualRebate />,
    vip: <Vip setTab={selectTab} />,
  };

  useEffect(() => {
    if (accountModal?.status && accountModal?.type && screens[accountModal.type]) {
      setTab(accountModal.type);
    }
  }, [accountModal]);

  useEffect(() => {
    const fromQuery = params.get("tab");
    if (fromQuery && screens[fromQuery]) setTab(fromQuery);
  }, [params]);

  useEffect(() => {
    const rail = accountRail.current;
    const active = rail?.querySelector('[aria-current="page"]');
    if (active) rail.scrollTo({ left: active.offsetLeft - rail.offsetLeft - (rail.clientWidth - active.clientWidth) / 2, behavior: "smooth" });
  }, [tab]);



  return (
    <div data-v-c129d1f8 data-v-6577e1c3 className={`br_acmc_body${embedded ? " ref-member-embedded" : ""}`}>
      <OutsideClickHandler
        disabled={embedded}
        onOutsideClick={() => {
          if (!document.querySelector(".reference-rewards-overlay, .reference-unavailable-overlay, .reference-invite-bonus-overlay")) {
            setAccountModal({ type: "", status: false });
          }
        }}
      >
        <div data-v-c129d1f8 className="acmc_content">
          <div data-v-c129d1f8 className="br_acmc_main">
            <div data-v-c129d1f8 className="br_acmc_mleft">
              <div className="ref-member-summary">
                <img className="ref-member-avatar-img" src="/assets/Icon/0.webp" alt="" />
                <div className="ref-member-name">
                  {user?.user?.username || user?.username}
                  <span className="ref-member-vip">VIP0</span>
                </div>
                <p className="ref-member-joined">Day 0 of joining chorki</p>
                <div className="ref-member-wallet-actions">
                  <button type="button" className={tab === "deposit" ? "active" : ""} onClick={() => selectTab("deposit")}>
                    <i aria-hidden="true" className="acmc_icon icon_depositv2" />
                    Deposit
                  </button>
                  <button type="button" className={tab === "withdraw" ? "active" : ""} onClick={() => selectTab("withdraw")}>
                    <i aria-hidden="true" className="acmc_icon icon_withdraw" />
                    Withdrawal
                  </button>
                </div>
              </div>
              <div className="mobile-member-section">
                <div className="mobile-member-rail-heading"><span>Account section</span><span>Swipe to explore</span></div>
                <div className="mobile-member-rail-controls">
                  <button type="button" className="mobile-member-rail-arrow" aria-label="Previous account sections" onClick={() => accountRail.current?.scrollBy({ left: -220, behavior: "smooth" })}>‹</button>
                  <nav ref={accountRail} className="mobile-member-rail" aria-label="Account sections">
                    {[...NAV_ITEMS, ["deposit", "Deposit"], ["withdraw", "Withdrawal"]].map(([key, label, , , badge]) => {
                      const Icon = RAIL_ICONS[key];
                      return (
                      <button key={key} type="button" aria-current={tab === key ? "page" : undefined} className={tab === key ? "active" : ""} onClick={() => selectTab(key)}>
                        <Icon aria-hidden="true" className="mobile-member-rail-icon" />
                        <span>{label}</span>
                        {badge ? <em className="mobile-member-rail-badge">{badge}</em> : null}
                      </button>
                    );})}
                  </nav>
                  <button type="button" className="mobile-member-rail-arrow" aria-label="Next account sections" onClick={() => accountRail.current?.scrollBy({ left: 220, behavior: "smooth" })}>›</button>
                </div>
              </div>
              <ul data-v-c129d1f8 className="br_acmc_mlnav">
                {NAV_ITEMS.map(([key, label, icon, mc, badge]) => (
                  <li
                    key={key}
                    role="button"
                    tabIndex={0}
                    aria-current={tab === key ? "page" : undefined}
                    onKeyDown={(event) => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); selectTab(key); } }}
                    data-v-c129d1f8
                    data-mc={mc}
                    className={tab === key ? "active" : ""}
                    onClick={() => selectTab(key)}
                  >
                    <i data-v-c129d1f8 className={`acmc_icon ${icon}`} />
                    <span data-v-c129d1f8>{label}</span>
                    {badge ? <em className="ref-member-nav-badge">{badge}</em> : null}
                  </li>
                ))}
              </ul>
            </div>
            <div data-v-c129d1f8 id="br_proxy_right" className="br_acmc_mright">
              {screens[tab] || screens.account}
            </div>
          </div>
          {!embedded && (
            <div
              onClick={() => setAccountModal({ type: "", status: false })}
              data-v-c129d1f8
              className="close_btn"
            />
          )}
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default Index;
